const pickValue = (source, keys = []) => {
  for (const key of keys) {
    if (typeof source?.[key] !== 'undefined' && source[key] !== null) {
      return source[key];
    }
  }

  return null;
};

export const normalizePhone = (value = '') => String(value || '').replace(/\D/g, '');

export const formatPhoneLabel = (value = '') => {
  const digits = normalizePhone(value);

  if (!digits) return '-';
  if (digits.length === 13 && digits.startsWith('55')) {
    return `+${digits.slice(0, 2)} (${digits.slice(2, 4)}) ${digits.slice(4, 9)}-${digits.slice(9)}`;
  }

  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }

  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return `+${digits}`;
};

export const isSupportSpecialist = (name = '') => {
  const normalizedName = String(name || '').toLowerCase();
  return normalizedName.includes('garantia') || normalizedName.includes('suporte');
};

export const buildSpecialistWhatsappMessage = (name = '') => {
  if (isSupportSpecialist(name)) {
    return 'Ola, vim atraves do Site da Hi Cell, comprei um produto com voces e ele apresentou um problema';
  }

  return `Ola, ${name}! Vim pelo site da HiCell e gostaria de saber mais sobre os produtos.`;
};

export const getSpecialistWhatsappLink = ({ phone, name }) => {
  const sanitizedPhone = normalizePhone(phone);

  if (!sanitizedPhone) return '#';

  const encodedMessage = encodeURIComponent(buildSpecialistWhatsappMessage(name));
  return `https://wa.me/${sanitizedPhone}?text=${encodedMessage}`;
};

export const normalizeSpecialist = (item = {}, index = 0) => {
  const id = pickValue(item, ['id', 'Id']) ?? `specialist-${index}`;
  const name = pickValue(item, ['name', 'Name', 'title', 'Title']) ?? '';
  const phone =
    pickValue(item, ['phone', 'Phone', 'phoneNumber', 'PhoneNumber', 'whatsapp', 'Whatsapp']) ?? '';
  const imageLink =
    pickValue(item, ['imageLink', 'ImageLink', 'imageUrl', 'ImageUrl', 'photoUrl', 'PhotoUrl']) ??
    '';
  const active = pickValue(item, ['active', 'Active', 'isActive', 'IsActive']);
  const order = pickValue(item, ['order', 'Order', 'position', 'Position']);

  return {
    ...item,
    id,
    name: String(name),
    phone: String(phone),
    imageLink: String(imageLink),
    active: typeof active === 'undefined' || active === null ? true : Boolean(active),
    order: Number.isFinite(Number(order)) ? Number(order) : index + 1,
  };
};

export const normalizeSpecialists = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item, index) => normalizeSpecialist(item, index))
    .sort((first, second) => {
      if (first.active !== second.active) {
        return first.active ? -1 : 1;
      }

      if (first.order !== second.order) {
        return first.order - second.order;
      }

      return first.name.localeCompare(second.name);
    });
